"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserCurrentStateResponseMapper = void 0;
var GetUserCurrentStateResponseMapper = /** @class */ (function () {
    function GetUserCurrentStateResponseMapper(data) {
        this.localData = data;
    }
    GetUserCurrentStateResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return GetUserCurrentStateResponseMapper;
}());
exports.GetUserCurrentStateResponseMapper = GetUserCurrentStateResponseMapper;
//# sourceMappingURL=GetUserCurrentStateResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/models/mappers/GetUserCurrentStateResponseMapper.js
// module id = 1498
// module chunks = 8